let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1QdXB"), load("6wr18"), load("ffEVr"), load("8Gekp"), load("aSmvL")]).then(() => parcelRequire('1TWCG'));